import { LevelType } from 'data/types';
import { collectConditionedHybridSpaces } from 'utils/hybrid-config-spaces';

// A "mini-split room" on the hybrid path is a user-placed conditioned space
// on a conditioned level — everything that is not the auto-generated
// whole-level leftover (isAutoLayoutSpace). With none, the hybrid project is
// a whole-house ducted job and System Design has nothing to add.
export function hasHybridDuctlessSpaces(
  structure: LevelType[],
  autoLayoutSpaceIds: readonly string[]
): boolean {
  return (
    collectConditionedHybridSpaces(structure, autoLayoutSpaceIds).userPlaced
      .length > 0
  );
}
